import { formatCents } from '@core/money'
import type { Window } from '@core/home'
import { Card } from '@design/components'

/**
 * What is coming, over three horizons.
 *
 * The Planner view is deliberately not in V1 (spec §1591: "7/30/90 totals on
 * Home suffice"), so this is the whole forecast — which makes the honesty of
 * it matter more, not less. Committed and Estimated are shown as two numbers,
 * never one: a forecast that silently mixes fact and guess is worse than no
 * forecast at all (§10).
 */
export function Totals({ windows }: { windows: Window[] }) {
  const live = windows.filter((w) => w.count > 0)
  if (live.length === 0) return null

  return (
    <Card className="mb-3">
      {live.map((window) => (
        <div
          key={window.days}
          className="flex items-baseline justify-between py-1.5 first:pt-0 last:pb-0"
        >
          <span className="text-sm text-muted">{window.label}</span>
          <span className="text-right">
            <span className="tabular-nums font-medium">
              {formatCents(window.committedCents)}
            </span>
            {window.estimatedCents > 0 && (
              <span className="block text-xs text-muted tabular-nums">
                + {formatCents(window.estimatedCents)} geschat
              </span>
            )}
          </span>
        </div>
      ))}
    </Card>
  )
}
